import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import './app/styles/tokens.css';
import './app/styles/globals.css';
import { initTelemetry, registerGlobalErrorHandlers } from './shared/monitoring/telemetry';

initTelemetry();
registerGlobalErrorHandlers();

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);
